import { Input, Skeleton, message } from "antd";
import { Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Button } from "../ui/button";
import useTopLevelReciprocalMatches from "@/hooks/queries/use-top-level-reciprocal-matches";
import useUpdateTopLevelReciprocalMatch from "@/hooks/mutations/use-update-top-level-reciprocal-match";

type ReciprocalMatch = {
  jobAdId: string;
  candidateId: string;
  businessId: string;
  businessName: string;
  roleTitle: string;
  timestamp: Timestamp;
  notes?: string;
};

const MatchNotes = ({
  jobAdId,
  candidateId,
}: {
  jobAdId: string;
  candidateId: string;
}) => {
  const [notes, setNotes] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [editing, setEditing] = useState<boolean>(false);

  // const q = query(
  //   collection(db, `TopLevelReciprocalMatches`),
  //   where("jobAdId", "==", jobAdId),
  //   where("candidateId", "==", candidateId)
  // );
  // const [snapshot, snapshotLoading, error] = useCollection(q);

  const {
    data: matches,
    isLoading: matchesLoading,
    error,
  } = useTopLevelReciprocalMatches({
    jobAdId,
    candidateId,
  });

  const { mutateAsync: updateMatch } = useUpdateTopLevelReciprocalMatch();

  useEffect(() => {
    setEditing(false);
    if (!matchesLoading && matches && matches?.length > 0) {
      const matchData = matches?.[0] as ReciprocalMatch;
      setNotes(matchData.notes ?? "");
    }
  }, [matches, matchesLoading, jobAdId, candidateId]); // Depend on snapshot and IDs to refetch on changes

  const saveNotes = async () => {
    const matchId = matches?.[0]?.id;
    if (!matchId) return;
    try {
      setLoading(true);

      await updateMatch({
        id: matchId,
        fields: { notes }, // TODO: check notes
      });

      // await updateDoc(doc(db, `TopLevelReciprocalMatches`, matchId), { notes });
      message.success("Anteckningarna sparades");
    } catch (e) {
      console.error(e);
      message.error("Något gick fel");
    } finally {
      setLoading(false);
      setEditing(false);
    }
  };

  if (matchesLoading) return <Skeleton active paragraph />;
  if (error || !matches) return <p>Error: {error?.message}</p>;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Anteckningar</CardTitle>
        <CardDescription>Lägg till anteckningar om kandidaten</CardDescription>
      </CardHeader>

      <CardContent>
        <CustomTextArea
          disabled={!editing}
          value={notes} // Control this component with the notes state
          onChange={(e) => setNotes(e.target.value)}
        />
      </CardContent>
      <CardFooter>
        {editing ? (
          <Button onClick={saveNotes} disabled={loading}>
            Spara
          </Button>
        ) : (
          <Button onClick={() => setEditing(true)}>Redigera</Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default MatchNotes;

const CustomTextArea = styled(Input.TextArea)`
  &.ant-input-disabled {
    background-color: transparent;
    color: inherit;
  }
`;
